import React from 'react';

import DeliveryItem from './Delivery';
import DeliveryItemContainer from './Delivery/ItemContainer';

import ActivitiesItem from './Activities';
import ActivitiesItemContainer from './Activities/ItemContainer';

const Item = ({ data }) => {

    switch(data.context) {
        case 'activities':
            return (
                <ActivitiesItemContainer data={data}>
                    <ActivitiesItem data={data} />
                </ActivitiesItemContainer>
            );

        default:
            return (
                <DeliveryItemContainer data={data}>
                    <DeliveryItem data={data} />
                </DeliveryItemContainer>
            );

    }

}

export default Item;



// WEBPACK FOOTER //
// ./src/components/Timeline/Item.js